import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { useNavigate, useLocation } from "react-router-dom"; 
import { SIDE_MENU_DATA, SIDE_MENU_USER_DATA } from "../../utils/data";
import { BASE_URL } from "../../utils/apiPaths";

const SideMenu = () => {
  const { user, clearUser } = useContext(UserContext);
  const [sideMenuData, setSideMenuData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation(); 

  const handleClick = (route) => {
    if (route === "logout") {
      handleLogout();
      return;
    }
    navigate(route);
  };

  const handleLogout = () => {
    localStorage.clear();
    clearUser();
    navigate("/login");
  };

  useEffect(() => {
    if (user) {
      setSideMenuData(
        user?.role === "admin" ? SIDE_MENU_DATA : SIDE_MENU_USER_DATA
      );
    }
  }, [user]);

  return (
    <div className="w-64 bg-white shadow-md h-screen p-4 sticky top-0 overflow-y-auto flex flex-col">
      {/* Profil */}
      <div className="flex flex-col items-center mb-6">
        <img
          src={`${BASE_URL}${user?.profileImageUrl}`}
          alt="Profil"
          className="w-20 h-20 bg-slate-400 rounded-full object-cover"
        />
        {user?.role === "admin" && (
          <div className="text-xs font-semibold bg-blue-600 px-3 py-0.5 rounded mt-1 text-white">
            Admin
          </div>
        )}
        <h5 className="text-lg font-semibold text-gray-950">
          {user?.name || "Utilisateur"}
        </h5>
        <p className="text-sm text-gray-500">{user?.email || ""}</p>
      </div>

      {/* Menu */}
      <div className="">
        {sideMenuData.map((item, index) => {
          const isActive = location.pathname === item.path; 
          return (
            <button
              key={`menu_${index}`}
              className={`flex w-full items-center gap-4 text-[15px] px-6 py-3 mb-2 rounded-lg cursor-pointer transition
                ${
                  isActive
                    ? "text-black bg-gradient-to-r from-blue-50 to-blue-100 border-r-4 border-blue-500"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              onClick={() => handleClick(item.path)}
            >
              <item.icon className="text-xl" />
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SideMenu;
